
import { useMemo, useState } from "react";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";


import { useRef, useEffect, useCallback } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Flatpickr from 'react-flatpickr';
import Box from '@mui/material/Box';
import moment from 'moment';
import api_core from '../../../services/config.js';
import PropTypes from "prop-types";
import { esES } from '@mui/x-data-grid/locales';
import { Button, IconButton } from '@mui/material';
import SoftTypography from 'components/SoftTypography/index.js';
import Operacion from 'Repository/Operacion.js';
import { DataGridFilter } from "../components/DataGridFilter.js";
import ListadoCreditos from "layouts/dashboard/components/ListadoCreditos.jsx";
import { ArrowBack, ArrowBackIos, ArrowBackIosNew } from "@mui/icons-material";

moment.locale('es-MX');

const columns = [
    { field: 'uuid', headerName: 'uuid' },
    {
        field: 'rfc',
        headerName: 'RFC',
        headerAlign: 'center',
        align: "center",
        flex: 1,
        minWidth: 150,
        maxWidth: 350,
    },
    {
        field: 'rs',
        headerName: 'Razón social',
        headerAlign: 'center',
        align: "center",
        flex: 1,
        minWidth: 150,
        maxWidth: 350,
    },
    {
        field: 'created',
        headerName: 'Fecha',
        headerAlign: 'center',
        align: "center",
        flex: 1,
        minWidth: 150,
        maxWidth: 350,
        valueFormatter: (params) => {
            if (!params) return '';
            const date = new Date(params);
            return new Intl.DateTimeFormat('es-MX', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
            }).format(date);
        },
    },
    {
        field: 'op_compradas',
        headerName: 'Operaciones Compradas',
        headerAlign: 'center',
        align: "center",
        flex: 1,
        minWidth: 150,
        maxWidth: 400,
    },
    {
        field: 'op_realizadas',
        headerName: 'Operaciones Realizadas',
        headerAlign: 'center',
        align: "center",
        flex: 1,
        minWidth: 150,
        maxWidth: 400,
    },
    {
        field: 'op_restantes',
        headerName: 'Operaciones Restantes',
        headerAlign: 'center',
        align: "center",
        flex: 1,
        minWidth: 150,
        maxWidth: 400,
    },
];

export function ReportesCreditos() {
    const [filter, setFilter] = useState({
        search: '',
        startDate: '',
        endDate: '',
    });

    const [detailsFilter, setDetailsFilter] = useState({
        startDate: '',
        endDate: '',
    });

    const [rfcDetails, setRfcDetails] = useState(null);

    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState({ dataGrid: false, isGeneratingReport: false });
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 15 });

    const mapPageToNextCursor = useRef({});
    const [hasNextPage, setHasNextPage] = useState(true);

    const rowCount = useRef(0);
    const isCountRows = useRef(true);

    const operacion = new Operacion();

    const currentFilter = useMemo(() => rfcDetails ? detailsFilter : filter, [rfcDetails, detailsFilter, filter]);

    function createCreditosUrl(endPoint, page, pageSize, isReport) {

        const params = new URLSearchParams();

        if (pageSize) {
            params.append('limit', pageSize);
        }

        if (page > 0 && mapPageToNextCursor.current[page - 1]) {
            params.append('cursor', mapPageToNextCursor.current[page - 1]);
        }

        if (currentFilter?.startDate) {
            const formattedStartDate = moment(currentFilter.startDate, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00');
            params.append('start_date', formattedStartDate)
        }

        if (currentFilter?.endDate) {
            const formattedEndDate = moment(currentFilter.endDate, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59');
            params.append('end_date', formattedEndDate)
        }

        if (currentFilter?.search || rfcDetails) {
            params.append('search', currentFilter.search || rfcDetails);
        }

        if (isReport) params.append('report', 'true');

        return `panel/creditos/${endPoint}?${params.toString()}`;
    }

    const fetchData = useCallback(async (page, pageSize) => {
        try {
            setLoading((prev) => ({ ...prev, dataGrid: true }));

            const url = createCreditosUrl('empresas', page, pageSize);

            const response = await operacion.transaction('GET', url, false, true);

            setRows(response.rows);
            setHasNextPage(response.hasNextPage);

            if (response.rows.length > 0 && isCountRows.current) {
                rowCount.current += response.rows.length;
            }

            if (!response.hasNextPage) {
                isCountRows.current = false;
            }

            if (response.cursor) {
                mapPageToNextCursor.current[page] = response.cursor;
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading((prev) => ({ ...prev, dataGrid: false }));
        }
    }, [filter, api_core]);

    const handlePageChange = (newPage) => {
        if (newPage > paginationModel.page && !hasNextPage) return;
        setPaginationModel((prev) => ({ ...prev, page: newPage }));
    };

    const handleRowClick = (params) => {
        setRfcDetails(params.row.rfc);
        setDetailsFilter({ startDate: '', endDate: '' });
    }

    const handleGenerateReport = useCallback(async (params) => {
        try {
            setLoading((prev) => ({ ...prev, isGeneratingReport: true }))

            const reportFor = rfcDetails ? 'consultar' : 'empresas';

            const urlReport = createCreditosUrl(reportFor, false, false, true);

            const response = await operacion.blobTransaction('GET', urlReport, false, true);

            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const timestamp = moment().format('YYYYMMDD_HHmmss');
            
            const reportName = rfcDetails ? `RFC_${rfcDetails}`:'Empresas';
            a.download = `Reporte_Creditos_${reportName}-${timestamp}.xlsx`;

            document.body.appendChild(a);
            a.click();
            a.remove();

        } catch (error) {
        }
        finally {
            setLoading((prev) => ({ ...prev, isGeneratingReport: false }))
        }
    }, [rfcDetails, currentFilter]);

    const handleFilterChange = useCallback((name, value) => {

        const setState = rfcDetails ? setDetailsFilter : setFilter;

        if (name == 'clean') {

            setState(prev =>
                Object.fromEntries(
                    Object.keys(prev).map(key => [key, ''])
                )
            );
        } else {

            setState((prev) => ({ ...prev, [name]: value }));
        }
    }, [rfcDetails, currentFilter]);

    const prevFilters = useRef(filter);

    useEffect(() => {
        const filtersChanged = prevFilters.current != filter;

        if (filtersChanged) {

            mapPageToNextCursor.current = {};
            rowCount.current = 0;
            isCountRows.current = true;

            if (paginationModel.page !== 0) {
                setPaginationModel(prev => ({ ...prev, page: 0 }));

                prevFilters.current = filter;
                return;
            }

            prevFilters.current = filter;
        }

        fetchData(paginationModel.page, paginationModel.pageSize);
    }, [filter, paginationModel.page, paginationModel.pageSize, fetchData]);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            {rfcDetails && (
                <SoftTypography>
                    <IconButton aria-label="volver" onClick={() => setRfcDetails(null)}>
                        <ArrowBackIos />
                    </IconButton>
                    <b>RFC:</b> {rfcDetails}
                </SoftTypography>
            )}

            <DataGridFilter filter={(rfcDetails != null ? detailsFilter : filter)} handleFilterChange={handleFilterChange} handleGenerateReport={handleGenerateReport} loading={loading.isGeneratingReport} />

            <Box sx={{ height: 700, width: '100%' }}>

                {!rfcDetails ? (
                    <DataGrid
                        cellClassName
                        rows={rows}
                        columns={columns}
                        paginationMode="server"
                        sortingMode="server"
                        paginationModel={paginationModel}
                        onPaginationModelChange={(model) => handlePageChange(model.page)}
                        pageSizeOptions={[15]}
                        rowCount={isCountRows.current ? -1 : rowCount.current}
                        loading={loading.dataGrid}
                        getRowId={(row) => row.uuid}
                        onRowClick={handleRowClick}
                        columnVisibilityModel={{
                            uuid: false,
                        }}
                        disableColumnMenu={true}
                        disableColumnSorting={true}
                        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                        sx={{
                            '& .MuiDataGrid-row:hover': {
                                cursor: 'pointer',
                                color: '#FFFFFF',
                                backgroundColor: '#5F9BC4',
                            },
                            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                                outline: 'none !important'
                            },
                            '& .MuiDataGrid-row:nth-of-type(even)': {
                                backgroundColor: '#FFFFFF',
                                '&:hover': {
                                    backgroundColor: '#5F9BC4'
                                }
                            },
                            '& .MuiDataGrid-row:nth-of-type(odd)': {
                                backgroundColor: '#DCF1FF',
                                '&:hover': {
                                    backgroundColor: '#5F9BC4'
                                }
                            },
                            '& .MuiDataGrid-columnHeaders': {
                                borderTopRightRadius: '0.7rem',
                                borderTopLeftRadius: '0.7rem',
                            },
                            '& .MuiDataGrid-columnHeader': {
                                backgroundColor: '#999999',
                                color: '#F2F2F2',
                                margin: '0 0.1rem 0 0',
                                height: '3rem !important',
                                borderTopLeftRadius: '0.7rem',
                                borderTopRightRadius: '0.7rem',
                            },
                            '& .MuiDataGrid-columnHeader:focus': {
                                outline: 'none !important'
                            },
                            '& .MuiCircularProgress-root': {
                                color: '#4A80A8'
                            }
                        }}
                    />) : (

                    <ListadoCreditos rfc={rfcDetails} dates={detailsFilter} />
                )}
            </Box>
        </DashboardLayout>
    );
}
